import React from 'react';
import LoadingIndicator from '../../../components/Global/loading-indicator/loading-indicator';
import { GetPromos } from '../../../api/home';
import { useQuery } from '@tanstack/react-query';
import './quick-links.scss';
import QuickLinkCarousel from '../Quick-Links-Carousel';

export default function QuickLinks() {
  const getPromosQuery = useQuery({
    queryKey: ['getPromos'],
    queryFn: async () => JSON.parse(await GetPromos()()),
  });

  if (getPromosQuery.isLoading) return <LoadingIndicator />;

  if (
    getPromosQuery.isSuccess &&
    Array.isArray(getPromosQuery.data) &&
    getPromosQuery.data.length > 0
  ) {
    return <QuickLinkCarousel promos={getPromosQuery.data} />;
  }

  return <></>;
}
